import {Box} from '@chakra-ui/react'
import {ReactNode} from 'react'
import ElementsSizesEnum from '../../../enums/ElementsSizesEnum/ElementsSizesEnum'

type Props = {
  children: ReactNode;
};
export const CartSidebar = ({ children }: Props) => {
  return (
    <Box
      pb={20}
      position={{ lg: 'sticky' }}
      bottom={0}
      overflowY={{ lg: 'auto' }}
      maxH={`calc(100vh - ${ElementsSizesEnum.NAVBAR_HEIGHT.lg})`}
      top={{ lg: ElementsSizesEnum.NAVBAR_HEIGHT.lg }}
      gridRow={{ lg: '1 / -1' }}
    >
      {children}
    </Box>
  )
}
